import { Close } from "@mui/icons-material";
import { Dialog, IconButton, Tooltip } from "@mui/material";
import { CSSProperties, FC, useState } from "react";
import "./DocImage.scss";

interface Props {
	src: string;
	id?: string;
	style?: CSSProperties;
}

const DocImage: FC<Props> = (props: Props) => {
	const [open, setOpen] = useState(false);

	return (
		<>
			<Tooltip title="Clique para ampliar">
				<img
					className="doc-image"
					src={props.src}
					id={props.id}
					style={props.style}
					alt="Exemplo"
					onClick={() => setOpen(true)}
				/>
			</Tooltip>
			<Dialog
				open={open}
				onClose={() => setOpen(false)}
				className="doc-image-dialog"
				maxWidth={false}
			>
				<IconButton className="doc-image-close" onClick={() => setOpen(false)}>
					<Close/>
				</IconButton>
				<img className="doc-image-full" src={props.src} alt="Exemplo"/>
			</Dialog>
		</>
	);
}

export default DocImage;